import {styled, VariantProps} from "@phntms/css-components";
import styles from "./styles.module.scss";
import { marginVariants } from "../../style-variants";



export const SectionContainer = styled('section' , {
  css: ['std-section', styles.section ],
  variants: {
    ...marginVariants,
    bgImage: {
      true: styles.withBgImage
    }
  },
  defaultVariants: {
    margin: 'verticalLarge'
  }
})

export type SectionMarginValues = VariantProps<typeof SectionContainer>["margin"];

